export enum BooleanString {
	True = 'true',
	False = 'false',
}
